import React from "react";
import { Box, Tab, Tabs, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import FieldLabelsSettings from "./FieldLabels";
import CustomFieldDefinitionsSettings from "./CustomFieldDefinitions";

const CustomFieldsSettings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialTab = location.state?.tab === 1 ? 1 : 0;
  const [tab, setTab] = React.useState(initialTab);

  const returnTo = location.state?.returnTo;
  const returnTypeName = location.state?.returnTypeName;
  const returnTypeId = location.state?.returnTypeId;
  const returnTypeSnapshot = location.state?.returnTypeSnapshot;

  const handleBackToType = () => {
    navigate(returnTo || "/settings/types", {
      state: returnTypeId
        ? {
            reopenTypeId: returnTypeId,
            returnTypeSnapshot,
          }
        : undefined,
    });
  };

  return (
    <Box>
      {returnTo && (
        <Box sx={{ mb: 2 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBackToType}
            sx={{ mb: 0.5 }}
          >
            Voltar para edição do tipo
            {returnTypeName ? `: ${returnTypeName}` : ""}
          </Button>
          <Typography variant="body2" color="text.secondary">
            Você saiu do formulário do tipo de atendimento. Use o botão acima para continuar a
            edição.
          </Typography>
        </Box>
      )}
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label="Labels (legado)" />
        <Tab label="Campos por tipo" />
      </Tabs>
      {tab === 0 && <FieldLabelsSettings />}
      {tab === 1 && (
        <CustomFieldDefinitionsSettings
          presetScope={location.state?.presetScope}
          presetScopeId={location.state?.presetScopeId}
        />
      )}
    </Box>
  );
};

export default CustomFieldsSettings;
